export const policies = {
  terms_and_conditions: 'Terms & Conditions',
  allergy: 'Allergy Policy',
  privacy: 'Privacy Policy',
  cookies: 'Cookies',
  misc: 'Other Policy Information',
  // This text should be hidden if there is no policy, unless someone navigates directly to this URL
  policy_fallback: 'This marketplace has no other policy information.',
  cookies_fallback: 'This marketplace has no cookie information.',
  cookie_consent_banner_label: 'Cookie consent',
  cookie_consent_message:
    'We use cookies to analyse site usage and improve your experience, choose to accept or reject optional cookies.',
  cookie_consent_policy_prefix: 'For more details, see our',
  cookie_consent_policy_link: 'Cookie Policy.',
  cookie_consent_accept: 'Accept',
  cookie_consent_reject: 'Reject',
  manage_cookie_preferences: 'Manage Cookie Preferences',
}
